import React, { useEffect, useState } from "react";

import Select from "react-select";
import CreatableSelect from "react-select/creatable";

import TableLoader from "../../components/Loaders/TableLoader";
import { ErrorAlert, SuccessAlert } from "../../utils/Alerts";
import { shortDateYMD } from "../../utils/DateHelper";

import ScansSchema from "../../schemas/scans.schema";
import MeasurementsSchema from "../../schemas/measurements.schema";

import MeasurementsAPI from "../../API/measurements.api";
import MaterialsAPI from "../../API/materials.api";
import LookupsAPI from "../../API/lookups.api";
import ScansAPI from "../../API/scans.api";
import { getUserEmail, getUserId } from "../../utils/OktaHelpers";
import LogCapture from "../../utils/LogManagement/LogHelper";
import ValidationError from "../../components/Shared/ValidationError";
import { validate } from "../../utils/ValidationHelpers";
import { getReactSelectTheme } from "../../utils/ReactSelectStyles";
import { ACTIONS, ENTITIES } from "../../utils/LogManagement/LogConstants";

const scan = {
    type: "Spectrum",
    // materialId: "63ce8cdc-cc9a-4846-8951-2f64e7552673", //Value Selected By User
    // name: "scan for superAdmin", //Value Entered By User
    // modelId: "bc82ef44-afb0-464b-a474-8ec1b1259fca", //Value Selected By User
    // capturedAt: "2021-07-28T16:41:21.303Z", //Value Entered By User
    numberOfPoints: 257,
    settings: {
        scanTime: 5000,
        FFTPoints: "32k points",
        apodization: "Boxcar",
        interpolation: "257 points",
        gain: "Default (0)",
    },
    wavenumber: [
        3921.5686544775963, 3935.185205191374, 3948.801765218377,
        3962.4183159321547, 3976.034875959158, 3989.6514266729355,
        4003.267986699939, 4016.8845374137163, 4030.5010974407196,
        4044.117648154497, 4057.7342081815004, 4071.350758895278,
        4084.9673189222813, 4098.583869636059, 4112.200429663062,
        4125.81698037684, 4139.433540403843, 4153.0500911176205,
        4166.666651144624, 4180.283201858401, 4193.899761885405,
        4207.516312599182, 4221.132872626185, 4234.749423339963,
        4248.365983366966, 4261.982534080744, 4275.599094107747,
        4289.215644821525, 4302.832204848528, 4316.448755562305,
        4330.065315589309, 4343.681866303086, 4357.29842633009,
        4370.914977043867, 4384.53153707087, 4398.148087784648,
        4411.764647811651, 4425.381198525429, 4438.997758552432,
        4452.61430926621, 4466.230869293213, 4479.84742000699,
        4493.463980033994, 4507.080530747771, 4520.697090774775,
        4534.313641488552, 4547.930201515555, 4561.546752229333,
        4575.163312256336, 4588.779862970114, 4602.396422997117,
        4616.012973710895, 4629.629533737898, 4643.246084451675,
        4656.862644478679, 4670.479195192456, 4684.0957552194595,
        4697.712305933237, 4711.32886596024, 4724.945416674018,
        4738.561976701021, 4752.178527414799, 4765.795087441802,
        4779.41163815558, 4793.028198182583, 4806.64474889636,
        4820.261308923364, 4833.877859637141, 4847.4944196641445,
        4861.110970377922, 4874.727530404925, 4888.344081118703,
        4901.960641145706, 4915.577191859484, 4929.193751886487,
        4942.810302600265, 4956.426862627268, 4970.043413341045,
        4983.659973368049, 4997.276524081826, 5010.8930841088295,
        5024.509634822607, 5038.12619484961, 5051.742745563388,
        5065.359305590391, 5078.975856304169, 5092.592416331172,
        5106.2089670449495, 5119.825527071953, 5133.44207778573,
        5147.058637812734, 5160.675188526511, 5174.2917485535145,
        5187.908299267292, 5201.524859294295, 5215.141410008073,
        5228.757970035076, 5242.374520748854, 5255.991080775857,
        5269.6076314896345, 5283.224191516638, 5296.840742230415,
        5310.457302257419, 5324.073852971196, 5337.6904129981995,
        5351.306963711977, 5364.92352373898, 5378.540074452758,
        5392.156634479761, 5405.773185193539, 5419.389745220542,
        5433.0062959343195, 5446.622855961323, 5460.2394066751,
        5473.855966702104, 5487.472517415881, 5501.089077442884,
        5514.705628156662, 5528.322188183665, 5541.938738897443,
        5555.555298924446, 5569.171849638224, 5582.788409665227,
        5596.4049603790045, 5610.021520406008, 5623.638071119785,
        5637.254631146789, 5650.871181860566, 5664.487741887569,
        5678.104292601347, 5691.72085262835, 5705.337403342128,
        5718.953963369131, 5732.570514082909, 5746.187074109912,
        5759.8036248236895, 5773.420184850693, 5787.03673556447,
        5800.653295591474, 5814.269846305251, 5827.886406332254,
        5841.502957046032, 5855.119517073035, 5868.736067786813,
        5882.352627813816, 5895.969178527594, 5909.585738554597,
        5923.202289268374, 5936.818849295378, 5950.435400009155,
        5964.051960036159, 5977.668510749936, 5991.285070776939,
        6004.901621490717, 6018.51818151772, 6032.134732231498,
        6045.751292258501, 6059.367842972279, 6072.984402999282,
        6086.600953713059, 6100.217513740063, 6113.83406445384,
        6127.4506244808435, 6141.067175194621, 6154.683735221624,
        6168.300285935402, 6181.916845962405, 6195.533396676183,
        6209.149956703186, 6222.766507416964, 6236.383067443967,
        6249.999618157744, 6263.616178184748, 6277.232728898525,
        6290.8492889255285, 6304.465839639306, 6318.082399666309,
        6331.698950380087, 6345.31551040709, 6358.932061120868,
        6372.548621147871, 6386.165171861649, 6399.781731888652,
        6413.398282602429, 6427.014842629433, 6440.63139334321,
        6454.2479533702135, 6467.864504083991, 6481.481064110994,
        6495.097614824772, 6508.714174851775, 6522.330725565553,
        6535.947285592556, 6549.5638363063335, 6563.180396333337,
        6576.796947047114, 6590.413507074118, 6604.030057787895,
        6617.6466178148985, 6631.263168528676, 6644.879728555679,
        6658.496279269457, 6672.11283929646, 6685.729390010238,
        6699.345950037241, 6712.9625007510185, 6726.579060778022,
        6740.195611491799, 6753.812171518803, 6767.42872223258,
        6781.0452822595835, 6794.661832973361, 6808.278393000364,
        6821.894943714142, 6835.511503741145, 6849.128054454923,
        6862.744614481926, 6876.3611651957035, 6889.977725222707,
        6903.594275936484, 6917.210835963488, 6930.827386677265,
        6944.4439467042685, 6958.060497418046, 6971.677057445049,
        6985.293608158827, 6998.91016818583, 7012.526718899608,
        7026.143278926611, 7039.7598296403885, 7053.376389667392,
        7066.992940381169, 7080.609500408173, 7094.22605112195,
        7107.842611148953, 7121.459161862731, 7135.075721889734,
        7148.692272603512, 7162.308832630515, 7175.925383344293,
        7189.541943371296, 7203.1584940850735, 7216.775054112077,
        7230.391604825854, 7244.008164852858, 7257.624715566635,
        7271.241275593638, 7284.857826307416, 7298.474386334419,
        7312.090937048197, 7325.7074970752, 7339.324047788978,
        7352.940607815981, 7366.557158529758, 7380.173718556762,
        7393.790269270539, 7407.406829297543,
    ],
    spectralData: [
        [
            2.721160533837974, 2.7108017704449594, 2.7015017345547676,
            2.6937680202536285, 2.688297280110419, 2.68566400045529,
            2.686081873252988, 2.689304854720831, 2.694710495416075,
            2.7014131541363895, 2.708550088573247, 2.715612470638007,
            2.7224076446145773, 2.7289818855933845, 2.7355143218301237,
            2.7422619867138565, 2.7495674905367196, 2.757892047520727,
            2.7678007958456874, 2.7798454160802066, 2.794366341549903,
            2.811278391163796, 2.8299562516622245, 2.8493096702732146,
            2.867994492407888, 2.885029965545982, 2.9001434333622456,
            2.9138051788322628, 2.927024767268449, 2.9409474111162126,
            2.956434281077236, 2.973797812592238, 2.992776653263718,
            3.012708469759673, 3.032762440852821, 3.0520936707034707,
            3.069850627798587, 3.0851118150167167, 3.096889704465866,
            3.1041954760439694, 3.1066486379131675, 3.1050062156282365,
            3.1008227495476604, 3.0962144024670124, 3.0931188841350377,
            3.0925114289857447, 3.093954490032047, 3.095772978849709,
            3.0958095798268914, 3.0924464343115687, 3.085379395633936,
            3.075759275816381, 3.0655792681500316, 3.056596464011818,
            3.049332497175783, 3.0425999430008233, 3.0340118799358606,
            3.021553182043135, 3.004623798187822, 2.9844983480870724,
            2.9638288193382323, 2.9454028350301087, 2.930792316328734,
            2.9195799259468913, 2.9095437843352556, 2.8977162553928792,
            2.8817845857702196, 2.861154288984835, 2.8371669934131205,
            2.8123869909904897, 2.7894964208826423, 2.769941312726587,
            2.7534315828233957, 2.738729619886726, 2.724463550839573,
            2.709865174256265, 2.6949917431920767, 2.6803987682797015,
            2.6665466954000294, 2.6533698313869536, 2.640279708430171,
            2.6265932945534587, 2.612090017646551, 2.5973183568567038,
            2.5834192521870136, 2.5715647381730378, 2.5623213150538504,
            2.5549301761202514, 2.5480521842837334, 2.540365164168179,
            2.531265199650079, 2.5211838888935745, 2.511364023666829,
            2.503247116692364, 2.497869380749762, 2.4956354056484997,
            2.496631711255759, 2.5013460079208016, 2.5113891228102148,
            2.5297751650214195, 2.5604946888051927, 2.6081641437485814,
            2.674820739775896, 2.75956658879295, 2.858686202671379,
            2.9658419312909245, 3.073296055663377, 3.1734854099340737,
            3.260404185857624, 3.3304546144790947, 3.3826625323854387,
            3.4183715819381177, 3.44060369534418, 3.45322237117216,
            3.4600422717630863, 3.464054292999208, 3.466916736215353,
            3.468833304941654, 3.4690497210249305, 3.466653113719076,
            3.461407427676022, 3.454276581760496, 3.4474523388780653,
            3.4438709379173815, 3.4464043681509793, 3.4570760326460004,
            3.476557566318661, 3.5040916758589447, 3.5378246917389333,
            3.5753720439970493, 3.6144183366559446, 3.6531611811369658,
            3.6903672269545496, 3.725621837656945, 3.7588447681628168,
            3.7899974966421723, 3.818944876547903, 3.8454191177152097,
            3.8691197871230543, 3.8898737519048154, 3.907790791708976,
            3.923296183347702, 3.9370134007185698, 3.949519817251712,
            3.9610550040379167, 3.9713641512207687, 3.9797809324227273,
            3.985515667591244, 3.9882940240204334, 3.9889057632535696,
            3.988834924530238, 3.9898375747725368, 3.993153863120824,
            3.998799913097173, 4.0052599622868, 4.009789333213121,
            4.0092720300890505, 4.001336637884378, 3.985245735384524,
            3.9621457690373063, 3.93460423219949, 3.9057293557561934,
            3.8783323019742966, 3.85465583531186, 3.835346212144941,
            3.8199768983758986, 3.8070485927164555, 3.7942216964438558,
            3.778806026093662, 3.758474125061184, 3.732071118429303,
            3.700300818309188, 3.6658472730778158, 3.6326860659755766,
            3.6046174238435924, 3.583548974711448, 3.5683631082065403,
            3.5549900494515896, 3.5376835498027503, 3.511786088347435,
            3.476619115099311, 3.4352509304881096, 3.3932489692233503,
            3.3561709336936474, 3.327144030481577, 3.3057128777727485,
            3.288438427262008, 3.2709033461287618, 3.2500076689757407,
            3.22532644495368, 3.198830410838127, 3.1732072588056326,
            3.1498912954702973, 3.1280094757676125, 3.1047819065861404,
            3.0779430526308715, 3.047790110576898, 3.0175306485034525,
            2.9918259126134217, 2.974085824098438, 2.9640465159900486,
            2.9571094433777034, 2.946068998426199, 2.924590080510825,
            2.890682453289628, 2.8482474735938013, 2.805719117168337,
            2.7723330073058605, 2.7538836700841784, 2.750358928460628,
            2.754703303799033, 2.7579079382121563, 2.7535802917554975,
            2.740407711826265, 2.7221606811508536, 2.705088665243238,
            2.6943132746964693, 2.6911406544968486, 2.692719653714448,
            2.6940763811580837, 2.691304194740951, 2.6839823462069035,
            2.6754445396363735, 2.6708838529884815, 2.67455872381106,
            2.6872737100347877, 2.7047349489293993, 2.7210038853809237,
            2.7314243954606354, 2.735397033393383, 2.7368028764612973,
            2.742080157622695, 2.757515269331634, 2.7875040424987674,
            2.8341794502921402, 2.8978790738619864, 2.9779642703942955,
            3.073615930043161, 3.184180718380958, 3.308837383519858,
            3.446482610888779, 3.5947713535279036, 3.7518802448175848,
            3.9166039670817554, 4.087555850856006, 4.261757456697524,
            4.433270136360079, 4.592833702918142, 4.729371832218021,
            4.8335502040572464, 4.902020888403058, 4.940284008625895,
            4.96205713134259, 4.984784312546253, 5.023069435264915,
            5.083487939555198, 5.161933088675141,
        ],
        [
            2.9694271041080356, 2.9558380134403706, 2.9457554453983903,
            2.9379750369116664, 2.931433462072164, 2.9256407520733774,
            2.9208620660938323, 2.9179613338783383, 2.917990228161216,
            2.9215066228061914, 2.927856717724353, 2.93563159648329,
            2.943055995274335, 2.948671206831932, 2.9519184725359082,
            2.9533905209973454, 2.9546448960900307, 2.9576508444733918,
            2.9640794382430613, 2.9747239546850324, 2.989293576683849,
            3.0066258390434086, 3.025195701047778, 3.0436678207479417,
            3.0612075701355934, 3.0777166597545147, 3.093425976112485,
            3.1085501657798886, 3.1230811844579875, 3.136783221270889,
            3.1493856571614742, 3.16083796788007, 3.1714844750240445,
            3.1820124480873346, 3.1931704375892878, 3.2053752336651087,
            3.218400734476745, 3.2313414034433663, 3.2428870792500675,
            3.251724597066641, 3.257208946160972, 3.259791841264814,
            3.2605786342173815, 3.260935377329588, 3.261864127125591,
            3.26350872637704, 3.265004011336714, 3.2647710875608027,
            3.261130361352116, 3.253000834956765, 3.240378468763083,
            3.2244094531051815, 3.207001381088048, 3.190147946588695,
            3.175241861026734, 3.162759926635772, 3.151823882944882,
            3.1411808100529015, 3.1296550412662327, 3.116584848612547,
            3.101953712757677, 3.086193243507296, 3.0698138405568898,
            3.053090220782906, 3.035953501239419, 3.0181361245922744,
            2.9994545155204833, 2.9800511663779616, 2.960437024012208,
            2.941304352134466, 2.923242119140923, 2.9063307098113,
            2.8900922276079655, 2.8737870045006275, 2.85671598976478,
            2.838528936263174, 2.819363062735647, 2.7997649856843054,
            2.7804426848888397, 2.7619969798251987, 2.7447486761957407,
            2.728720847517252, 2.713736251462251, 2.6995434192940593,
            2.685910218860954, 2.6726696523837745, 2.659713476896286,
            2.6469711679965258, 2.6345207821577787, 2.6226730784401298,
            2.6120174559764564, 2.603316225577146, 2.597242407500744,
            2.5940880994312465, 2.59363871300593, 2.5953469681553543,
            2.5988336419686675, 2.6045873761177063, 2.6145621319301426,
            2.6323508704081178, 2.6626568287611008, 2.710823423694819,
            2.7792248758487403, 2.8666362166404724, 2.9683166882023215,
            3.076408221386373, 3.1817182200029492, 3.276036470197141,
            3.3541024778969586, 3.4145117388106883, 3.4592946409247816,
            3.4924828680232167, 3.5183185944333673, 3.539784357417375,
            3.557903494220227, 3.571978211402893, 3.580384235829115,
            3.581708122510463, 3.576365963090211, 3.565968992188573,
            3.5532359033823013, 3.541376313660294, 3.5334179643541574,
            3.5317036788910627, 3.53759991703555, 3.5514412098564208,
            3.5726117086596787, 3.599717654287815, 3.6308820475824177,
            3.664117946755141, 3.697731567081064, 3.7306310143321753,
            3.762327437289059, 3.793011384550482, 3.8229465717449784,
            3.852160379756242, 3.88037784723565, 3.9071993087418377,
            3.9323848905041814, 3.9559904602356255, 3.978234389796853,
            3.9991430821828544, 4.018215415999293, 4.034394898917526,
            4.046453244518489, 4.053683578968048, 4.05653219204396,
            4.056726559065282, 4.056869097985327, 4.058920545503497,
            4.063172719907016, 4.068035224918276, 4.070695245172828,
            4.068481537979096, 4.060259484685957, 4.047114204149693,
            4.031929280608892, 4.018021991942078, 4.007513320539147,
            4.0002548368647695, 3.9939040667377412, 3.985131357330829,
            3.9713617064990103, 3.951923467684537, 3.929146146401763,
            3.9061843999661505, 3.885636245831847, 3.8683490944094956,
            3.8532113074325025, 3.837949549779296, 3.8204224896617234,
            3.799665963742882, 3.7761296844109893, 3.7510914262384176,
            3.7256944575347006, 3.7001788383349776, 3.673814341891557,
            3.64546311320737, 3.6143889534287155, 3.581059002317488,
            3.546917368657887, 3.513478906825185, 3.4816380124539137,
            3.4514346974901855, 3.4224413568153977, 3.394458582624793,
            3.3679580315947533, 3.3439542166888714, 3.323234326671809,
            3.3054457744583488, 3.288671956397593, 3.269907331559807,
            3.246338840108365, 3.21675461018458, 3.182386339176446,
            3.1470085377804935, 3.114437870681286, 3.087123727891594,
            3.0651866691187024, 3.0467002070508897, 3.0289459857158363,
            3.0099459923803806, 2.989374240860343, 2.9683899716474116,
            2.948445873335004, 2.9298972454853356, 2.911434054840356,
            2.890791103709489, 2.8662611730396748, 2.8380834264680743,
            2.8094033943489194, 2.7850061771459877, 2.76962403440848,
            2.7660239837132394, 2.773675706703216, 2.7887321659363806,
            2.805377752520144, 2.817832224536687, 2.822115726303309,
            2.8169975616037846, 2.8039708617143333, 2.7864186791703105,
            2.7684343745931983, 2.753782889340073, 2.745406562462449,
            2.7453843038529158, 2.7538237860426307, 2.769935503602028,
            2.791867172345519, 2.817277202848345, 2.844165498390794,
            2.8715476393699646, 2.8997138142585754, 2.930162602569908,
            2.965471788775176, 3.009118197951466, 3.065134456846863,
            3.137516719289124, 3.229584312066436, 3.343362163286656,
            3.4797317115589976, 3.63556663505733, 3.805771842598915,
            3.984064608812332, 4.163832450285554, 4.338895343244076,
            4.503827064763755, 4.653986461926252, 4.785542387980968,
            4.895793553441763, 4.983821138739586, 5.051557847764343,
            5.104603606741875, 5.15189579455182, 5.203613161575049,
            5.268273060210049, 5.349428777117282,
        ],
    ],
    predictions: [
        {
            parameterName: "Hydrogen", //Value comes from the selected model By User
            value: 20.403116250517634, // get the value from this function = () => { const precision = 1000000; const randomnum = Math.floor(Math.random() * (70 * precision - 10 * precision) + 1 * precision) / (1*precision);
        },
    ],
};
const measurement = {
    type: "Spectrum",
    // materialId: "63ce8cdc-cc9a-4846-8951-2f64e7552673", //ValueSelectedByUser
    // name: "measurement 2 by superadmin", //ValueEnteredByUser
    // createdAt: "2021-09-20T16:41:21.303Z",
    numberOfPoints: 257,
    settings: {
        scanTime: 5000,
        FFTPoints: "32k points",
        apodization: "Boxcar",
        interpolation: "257 points",
        gain: "Default (0)",
    },
    wavenumber: [
        3921.5686544775963, 3935.185205191374, 3948.801765218377,
        3962.4183159321547, 3976.034875959158, 3989.6514266729355,
        4003.267986699939, 4016.8845374137163, 4030.5010974407196,
        4044.117648154497, 4057.7342081815004, 4071.350758895278,
        4084.9673189222813, 4098.583869636059, 4112.200429663062,
        4125.81698037684, 4139.433540403843, 4153.0500911176205,
        4166.666651144624, 4180.283201858401, 4193.899761885405,
        4207.516312599182, 4221.132872626185, 4234.749423339963,
        4248.365983366966, 4261.982534080744, 4275.599094107747,
        4289.215644821525, 4302.832204848528, 4316.448755562305,
        4330.065315589309, 4343.681866303086, 4357.29842633009,
        4370.914977043867, 4384.53153707087, 4398.148087784648,
        4411.764647811651, 4425.381198525429, 4438.997758552432,
        4452.61430926621, 4466.230869293213, 4479.84742000699,
        4493.463980033994, 4507.080530747771, 4520.697090774775,
        4534.313641488552, 4547.930201515555, 4561.546752229333,
        4575.163312256336, 4588.779862970114, 4602.396422997117,
        4616.012973710895, 4629.629533737898, 4643.246084451675,
        4656.862644478679, 4670.479195192456, 4684.0957552194595,
        4697.712305933237, 4711.32886596024, 4724.945416674018,
        4738.561976701021, 4752.178527414799, 4765.795087441802,
        4779.41163815558, 4793.028198182583, 4806.64474889636,
        4820.261308923364, 4833.877859637141, 4847.4944196641445,
        4861.110970377922, 4874.727530404925, 4888.344081118703,
        4901.960641145706, 4915.577191859484, 4929.193751886487,
        4942.810302600265, 4956.426862627268, 4970.043413341045,
        4983.659973368049, 4997.276524081826, 5010.8930841088295,
        5024.509634822607, 5038.12619484961, 5051.742745563388,
        5065.359305590391, 5078.975856304169, 5092.592416331172,
        5106.2089670449495, 5119.825527071953, 5133.44207778573,
        5147.058637812734, 5160.675188526511, 5174.2917485535145,
        5187.908299267292, 5201.524859294295, 5215.141410008073,
        5228.757970035076, 5242.374520748854, 5255.991080775857,
        5269.6076314896345, 5283.224191516638, 5296.840742230415,
        5310.457302257419, 5324.073852971196, 5337.6904129981995,
        5351.306963711977, 5364.92352373898, 5378.540074452758,
        5392.156634479761, 5405.773185193539, 5419.389745220542,
        5433.0062959343195, 5446.622855961323, 5460.2394066751,
        5473.855966702104, 5487.472517415881, 5501.089077442884,
        5514.705628156662, 5528.322188183665, 5541.938738897443,
        5555.555298924446, 5569.171849638224, 5582.788409665227,
        5596.4049603790045, 5610.021520406008, 5623.638071119785,
        5637.254631146789, 5650.871181860566, 5664.487741887569,
        5678.104292601347, 5691.72085262835, 5705.337403342128,
        5718.953963369131, 5732.570514082909, 5746.187074109912,
        5759.8036248236895, 5773.420184850693, 5787.03673556447,
        5800.653295591474, 5814.269846305251, 5827.886406332254,
        5841.502957046032, 5855.119517073035, 5868.736067786813,
        5882.352627813816, 5895.969178527594, 5909.585738554597,
        5923.202289268374, 5936.818849295378, 5950.435400009155,
        5964.051960036159, 5977.668510749936, 5991.285070776939,
        6004.901621490717, 6018.51818151772, 6032.134732231498,
        6045.751292258501, 6059.367842972279, 6072.984402999282,
        6086.600953713059, 6100.217513740063, 6113.83406445384,
        6127.4506244808435, 6141.067175194621, 6154.683735221624,
        6168.300285935402, 6181.916845962405, 6195.533396676183,
        6209.149956703186, 6222.766507416964, 6236.383067443967,
        6249.999618157744, 6263.616178184748, 6277.232728898525,
        6290.8492889255285, 6304.465839639306, 6318.082399666309,
        6331.698950380087, 6345.31551040709, 6358.932061120868,
        6372.548621147871, 6386.165171861649, 6399.781731888652,
        6413.398282602429, 6427.014842629433, 6440.63139334321,
        6454.2479533702135, 6467.864504083991, 6481.481064110994,
        6495.097614824772, 6508.714174851775, 6522.330725565553,
        6535.947285592556, 6549.5638363063335, 6563.180396333337,
        6576.796947047114, 6590.413507074118, 6604.030057787895,
        6617.6466178148985, 6631.263168528676, 6644.879728555679,
        6658.496279269457, 6672.11283929646, 6685.729390010238,
        6699.345950037241, 6712.9625007510185, 6726.579060778022,
        6740.195611491799, 6753.812171518803, 6767.42872223258,
        6781.0452822595835, 6794.661832973361, 6808.278393000364,
        6821.894943714142, 6835.511503741145, 6849.128054454923,
        6862.744614481926, 6876.3611651957035, 6889.977725222707,
        6903.594275936484, 6917.210835963488, 6930.827386677265,
        6944.4439467042685, 6958.060497418046, 6971.677057445049,
        6985.293608158827, 6998.91016818583, 7012.526718899608,
        7026.143278926611, 7039.7598296403885, 7053.376389667392,
        7066.992940381169, 7080.609500408173, 7094.22605112195,
        7107.842611148953, 7121.459161862731, 7135.075721889734,
        7148.692272603512, 7162.308832630515, 7175.925383344293,
        7189.541943371296, 7203.1584940850735, 7216.775054112077,
        7230.391604825854, 7244.008164852858, 7257.624715566635,
        7271.241275593638, 7284.857826307416, 7298.474386334419,
        7312.090937048197, 7325.7074970752, 7339.324047788978,
        7352.940607815981, 7366.557158529758, 7380.173718556762,
        7393.790269270539, 7407.406829297543,
    ],
    spectralData: [
        2.721160533837974, 2.7108017704449594, 2.7015017345547676,
        2.6937680202536285, 2.688297280110419, 2.68566400045529,
        2.686081873252988, 2.689304854720831, 2.694710495416075,
        2.7014131541363895, 2.708550088573247, 2.715612470638007,
        2.7224076446145773, 2.7289818855933845, 2.7355143218301237,
        2.7422619867138565, 2.7495674905367196, 2.757892047520727,
        2.7678007958456874, 2.7798454160802066, 2.794366341549903,
        2.811278391163796, 2.8299562516622245, 2.8493096702732146,
        2.867994492407888, 2.885029965545982, 2.9001434333622456,
        2.9138051788322628, 2.927024767268449, 2.9409474111162126,
        2.956434281077236, 2.973797812592238, 2.992776653263718,
        3.012708469759673, 3.032762440852821, 3.0520936707034707,
        3.069850627798587, 3.0851118150167167, 3.096889704465866,
        3.1041954760439694, 3.1066486379131675, 3.1050062156282365,
        3.1008227495476604, 3.0962144024670124, 3.0931188841350377,
        3.0925114289857447, 3.093954490032047, 3.095772978849709,
        3.0958095798268914, 3.0924464343115687, 3.085379395633936,
        3.075759275816381, 3.0655792681500316, 3.056596464011818,
        3.049332497175783, 3.0425999430008233, 3.0340118799358606,
        3.021553182043135, 3.004623798187822, 2.9844983480870724,
        2.9638288193382323, 2.9454028350301087, 2.930792316328734,
        2.9195799259468913, 2.9095437843352556, 2.8977162553928792,
        2.8817845857702196, 2.861154288984835, 2.8371669934131205,
        2.8123869909904897, 2.7894964208826423, 2.769941312726587,
        2.7534315828233957, 2.738729619886726, 2.724463550839573,
        2.709865174256265, 2.6949917431920767, 2.6803987682797015,
        2.6665466954000294, 2.6533698313869536, 2.640279708430171,
        2.6265932945534587, 2.612090017646551, 2.5973183568567038,
        2.5834192521870136, 2.5715647381730378, 2.5623213150538504,
        2.5549301761202514, 2.5480521842837334, 2.540365164168179,
        2.531265199650079, 2.5211838888935745, 2.511364023666829,
        2.503247116692364, 2.497869380749762, 2.4956354056484997,
        2.496631711255759, 2.5013460079208016, 2.5113891228102148,
        2.5297751650214195, 2.5604946888051927, 2.6081641437485814,
        2.674820739775896, 2.75956658879295, 2.858686202671379,
        2.9658419312909245, 3.073296055663377, 3.1734854099340737,
        3.260404185857624, 3.3304546144790947, 3.3826625323854387,
        3.4183715819381177, 3.44060369534418, 3.45322237117216,
        3.4600422717630863, 3.464054292999208, 3.466916736215353,
        3.468833304941654, 3.4690497210249305, 3.466653113719076,
        3.461407427676022, 3.454276581760496, 3.4474523388780653,
        3.4438709379173815, 3.4464043681509793, 3.4570760326460004,
        3.476557566318661, 3.5040916758589447, 3.5378246917389333,
        3.5753720439970493, 3.6144183366559446, 3.6531611811369658,
        3.6903672269545496, 3.725621837656945, 3.7588447681628168,
        3.7899974966421723, 3.818944876547903, 3.8454191177152097,
        3.8691197871230543, 3.8898737519048154, 3.907790791708976,
        3.923296183347702, 3.9370134007185698, 3.949519817251712,
        3.9610550040379167, 3.9713641512207687, 3.9797809324227273,
        3.985515667591244, 3.9882940240204334, 3.9889057632535696,
        3.988834924530238, 3.9898375747725368, 3.993153863120824,
        3.998799913097173, 4.0052599622868, 4.009789333213121,
        4.0092720300890505, 4.001336637884378, 3.985245735384524,
        3.9621457690373063, 3.93460423219949, 3.9057293557561934,
        3.8783323019742966, 3.85465583531186, 3.835346212144941,
        3.8199768983758986, 3.8070485927164555, 3.7942216964438558,
        3.778806026093662, 3.758474125061184, 3.732071118429303,
        3.700300818309188, 3.6658472730778158, 3.6326860659755766,
        3.6046174238435924, 3.583548974711448, 3.5683631082065403,
        3.5549900494515896, 3.5376835498027503, 3.511786088347435,
        3.476619115099311, 3.4352509304881096, 3.3932489692233503,
        3.3561709336936474, 3.327144030481577, 3.3057128777727485,
        3.288438427262008, 3.2709033461287618, 3.2500076689757407,
        3.22532644495368, 3.198830410838127, 3.1732072588056326,
        3.1498912954702973, 3.1280094757676125, 3.1047819065861404,
        3.0779430526308715, 3.047790110576898, 3.0175306485034525,
        2.9918259126134217, 2.974085824098438, 2.9640465159900486,
        2.9571094433777034, 2.946068998426199, 2.924590080510825,
        2.890682453289628, 2.8482474735938013, 2.805719117168337,
        2.7723330073058605, 2.7538836700841784, 2.750358928460628,
        2.754703303799033, 2.7579079382121563, 2.7535802917554975,
        2.740407711826265, 2.7221606811508536, 2.705088665243238,
        2.6943132746964693, 2.6911406544968486, 2.692719653714448,
        2.6940763811580837, 2.691304194740951, 2.6839823462069035,
        2.6754445396363735, 2.6708838529884815, 2.67455872381106,
        2.6872737100347877, 2.7047349489293993, 2.7210038853809237,
        2.7314243954606354, 2.735397033393383, 2.7368028764612973,
        2.742080157622695, 2.757515269331634, 2.7875040424987674,
        2.8341794502921402, 2.8978790738619864, 2.9779642703942955,
        3.073615930043161, 3.184180718380958, 3.308837383519858,
        3.446482610888779, 3.5947713535279036, 3.7518802448175848,
        3.9166039670817554, 4.087555850856006, 4.261757456697524,
        4.433270136360079, 4.592833702918142, 4.729371832218021,
        4.8335502040572464, 4.902020888403058, 4.940284008625895,
        4.96205713134259, 4.984784312546253, 5.023069435264915,
        5.083487939555198, 5.161933088675141,
    ],
};

const SimulateSamples = () => {
    const [materials, setMaterials] = useState([]);
    const [models, setModels] = useState([]);
    const [users, setUsers] = useState([]);
    const [currentInput, setCurrentInput] = useState({
        capturedAt: shortDateYMD(new Date()),
    });
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isScan, setIsScan] = useState(true);
    const [defaultMaterial, setDefaultMaterial] = useState(null);
    const [defaultModel, setDefaultModel] = useState(null);
    const [defaultUser, setDefaultUser] = useState(null);

    const [isFormValid, setIsFormValid] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [error, setError] = useState({});

    useEffect(() => {
        getLookups();
    }, []);

    useEffect(() => {
        validate(
            currentInput,
            isScan ? ScansSchema : MeasurementsSchema,
            setIsFormValid,
            setError
        );
    }, [currentInput]);

    const getLookups = async () => {
        try {
            await getMaterial();
            await getModels();
            await getUsers();
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const getMaterial = async () => {
        try {
            const result = await LookupsAPI.getMaterials();
            if (result) {
                const newResults = result.map((record) => {
                    return { value: record.id, label: record.name };
                });
                setMaterials(newResults);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getModels = async () => {
        try {
            const result = await LookupsAPI.getDeployedModels();
            const newResults = result.map((model) => {
                return { label: model.modelName, value: model };
            });
            setModels(newResults);
        } catch (error) {
            console.log(error);
        }
    };

    const getUsers = async () => {
        try {
            const result = await LookupsAPI.getUsers();
            if (result) {
                const newResults = result.map((user) => {
                    setCurrentInput({
                        ...currentInput,
                        createdById: user.id,
                    });
                    return { label: user.email, value: user.id };
                });
                setUsers(newResults);
                setDefaultUser({
                    label: getUserEmail(),
                    value: getUserId(),
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleMaterialChange = (newValue) => {
        setCurrentInput({ ...currentInput, materialId: newValue?.value });
    };

    const handleModelChange = (newValue) => {
        setCurrentInput({ ...currentInput, model: newValue?.value });
    };

    const handleUserChange = (newValue) => {
        setCurrentInput({ ...currentInput, createdById: newValue?.value });
        setDefaultUser({ label: newValue?.label, value: newValue?.value });
    };

    const handleInputChange = (event) => {
        setCurrentInput({
            ...currentInput,
            [event.target.name]: event.target.value,
        });
    };

    const handleCreateMaterial = async (createdValue) => {
        setIsLoading(true);
        try {
            const result = await MaterialsAPI.addMaterial({
                name: createdValue,
                description: "",
            });
            setCurrentInput({ ...currentInput, materialId: result });
            setDefaultModel(
                currentInput.model
                    ? {
                          label: currentInput.model.modelName,
                          value: currentInput.model,
                      }
                    : null
            );
            setDefaultMaterial({ label: createdValue, value: result });
            getMaterial();
            LogCapture.info(
                `Material created with name: ${createdValue} & id: ${result}`,
                ENTITIES.materials,
                ACTIONS.materials.create
            );
        } catch (error) {
            ErrorAlert(error);
            LogCapture.error(
                `Couldn't create material with name: ${createdValue}, error: ${error}`
            );
        } finally {
            setIsLoading(false);
        }
    };

    const randomPredictionValue = () => {
        return 0.26;
    };

    const handleScan = async () => {
        setIsFormSubmitted(true);
        if (!isFormValid) {
            return;
        }
        setIsSubmitting(true);
        try {
            let predictions = currentInput.model?.modelParameters?.map(
                (parameter) => {
                    return {
                        parameterName: parameter,
                        value: randomPredictionValue(),
                    };
                }
            );
            const result = await ScansAPI.createScan({
                ...scan,
                name: currentInput.sampleName,
                capturedAt: currentInput.capturedAt,
                modelId: currentInput.model.id,
                createdById: currentInput.createdById,
                predictions: predictions,
            });
            if (result) {
                SuccessAlert(t("scanCreated"));
                LogCapture.info(
                    `Scan created with name: ${currentInput?.sampleName}`,
                    ENTITIES.scans,
                    ACTIONS.scans.create
                );
            }
        } catch (error) {
            ErrorAlert(error);
            LogCapture.error(
                `Couldn't create scan with name: ${currentInput?.sampleName}, error: ${error}`
            );
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleCollect = async () => {
        setIsFormSubmitted(true);
        if (!isFormValid) return;
        setIsSubmitting(true);
        try {
            const result = await MeasurementsAPI.createMeasurements({
                ...measurement,
                materialId: currentInput.materialId,
                name: currentInput.sampleName,
                createdAt: currentInput.capturedAt,
                createdById: currentInput.createdById,
            });
            if (result) {
                SuccessAlert("Collected");
                LogCapture.info(
                    `Measurements created with name: ${currentInput?.sampleName}`,
                    ENTITIES.measurements,
                    ACTIONS.measurements.create
                );
            }
        } catch (error) {
            ErrorAlert(error);
            LogCapture.error(
                `Couldn't create measurements with name: ${currentInput?.sampleName}, error: ${error}`
            );
        } finally {
            setIsSubmitting(false);
        }
    };

    if (isLoading) return <TableLoader isLoading={true} />;

    return (
        <>
            <div className="card-table shadow">
                <div className="upload-img-box flex">
                    <div className="w-full">
                        <div className="flex">
                            <h3 className="medium-title-bold">
                                Create Scans/Measurements
                            </h3>
                            <div className="flex items-center ml-auto">
                                <div className="upload-btn-area">
                                    <input
                                        type="radio"
                                        className="uploading-items-radio"
                                        name="uploading-items"
                                        id="local-radio"
                                        checked={isScan}
                                        onChange={() => setIsScan(true)}
                                    />
                                    <label
                                        className="upload-box"
                                        htmlFor="local-radio"
                                    >
                                        <span className="upload-box-text">
                                            Scan
                                        </span>
                                    </label>
                                </div>
                                <div className="upload-btn-area">
                                    <input
                                        type="radio"
                                        className="uploading-items-radio"
                                        name="uploading-items"
                                        id="cloud-radio"
                                        checked={!isScan}
                                        onChange={() => setIsScan(false)}
                                    />
                                    <label
                                        className="upload-box"
                                        htmlFor="cloud-radio"
                                    >
                                        <span className="upload-box-text">
                                            Collect
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <hr className="mt-2 mb-5" />
                        <div
                            className={`tags input-group ${
                                error.sampleName && isFormSubmitted
                                    ? "invalid-warning-input"
                                    : ""
                            }`}
                        >
                            <h4 className="uppercase text-xs">Sample name</h4>
                            <input
                                type="text"
                                name="sampleName"
                                value={currentInput.sampleName || ""}
                                onChange={handleInputChange}
                                className="input-element"
                                placeholder="Sample Name"
                            />
                            {isFormSubmitted && (
                                <ValidationError
                                    errorMessage={error.sampleName}
                                />
                            )}
                        </div>
                        {isScan && (
                            <div className="tags input-group w-full">
                                <h4 className="uppercase text-xs">Model</h4>
                                <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    isClearable
                                    isSearchable
                                    name="model"
                                    placeholder="Select Model..."
                                    options={models}
                                    onChange={handleModelChange}
                                    defaultValue={defaultModel || ""}
                                    theme={getReactSelectTheme}
                                />
                                {isFormSubmitted && (
                                    <ValidationError
                                        errorMessage={error.model}
                                    />
                                )}
                            </div>
                        )}
                        {!isScan && (
                            <div className="tags input-group">
                                <h4 className="uppercase text-xs">Material</h4>
                                <CreatableSelect
                                    className={`${
                                        error.materialId && isFormSubmitted
                                            ? "invalid-warning-input"
                                            : ""
                                    }`}
                                    classNamePrefix="select"
                                    isClearable
                                    isSearchable
                                    name="material"
                                    placeholder="Select Material..."
                                    options={materials}
                                    onChange={handleMaterialChange}
                                    onCreateOption={handleCreateMaterial}
                                    defaultValue={defaultMaterial || ""}
                                />
                                {isFormSubmitted && (
                                    <ValidationError
                                        errorMessage={error.materialId}
                                    />
                                )}
                            </div>
                        )}
                        <div
                            className={`tags input-group ${
                                error.capturedAt && isFormSubmitted
                                    ? "invalid-warning-input"
                                    : ""
                            }`}
                        >
                            <h4 className="uppercase text-xs">Captured At</h4>
                            <input
                                type="date"
                                name="capturedAt"
                                value={currentInput.capturedAt}
                                onChange={handleInputChange}
                                className="input-element"
                            />
                            {isFormSubmitted && (
                                <ValidationError
                                    errorMessage={error.capturedAt}
                                />
                            )}
                        </div>

                        <div className="tags input-group w-full">
                            <h4 className="uppercase text-xs">On Behalf Of</h4>
                            <Select
                                className="basic-single"
                                classNamePrefix="select"
                                isClearable
                                isSearchable
                                name="createdById"
                                placeholder="Select User..."
                                options={users}
                                onChange={handleUserChange}
                                value={defaultUser || ""}
                                theme={getReactSelectTheme}
                            />
                            {isFormSubmitted && (
                                <ValidationError
                                    errorMessage={error.createdById}
                                />
                            )}
                        </div>

                        <div className="main-customer-form-bnt flex items-center justify-end float-right mt-5">
                            <button
                                onClick={isScan ? handleScan : handleCollect}
                                className={`default-orange-outline-btn ${
                                    isSubmitting ? "disabled" : ""
                                }`}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    <>
                                        <span className="animate-spin mr-3 inline-flex">
                                            {" "}
                                            <i className="fas fa-sync"></i>
                                        </span>
                                        Requesting...
                                    </>
                                ) : (
                                    <>{isScan ? "Scan" : "Collect"}</>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SimulateSamples;
